// extracted by mini-css-extract-plugin
export default {"btns":"YoursBooking_btns__ZAkWN","bdy":"YoursBooking_bdy__2eP3u"};